<div class="bg-white p-5">
  <!-- Header bar -->
  <div class="page-title">
    <h1 class="text-xl font-bold text-dc-navy">
      {{ pageTitle ? pageTitle : ("MY_APPS.TITLE" | translate) }}
    </h1>

    <div
      class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between"
    >
      <app-button
        classesName="btn-edge-cut w-full lg:w-auto"
        [label]="
          serviceType == serviceName.MEDIATION
            ? ('MEDIATION_LIST.BTN_REQUEST' | translate)
            : ('MY_APPS.BTN_APPLY' | translate)
        "
        (onBtnClick)="applyForService()"
      >
      </app-button>

      <app-button
        classesName="card-edge-cut-white text-dc-navy w-full lg:w-auto"
        [label]="'BUTTONS.DOWNLOAD_MULTIPLE_CERTIFICATE' | translate"
        (onBtnClick)="downloadCertificates()"
      >
      </app-button>
       <app-button
        classesName="card-edge-cut-white text-dc-navy w-full lg:w-auto"
        [label]="'SUCCESS_PAGE.DOWNLOAD_RECEIPT' | translate"
        (onBtnClick)="downloadReceipts()"
      >
      </app-button>
      <app-button
        classesName="card-edge-cut-white text-dc-navy w-full lg:w-auto"
        [label]="'MY_APPS.BTN_EXPORT' | translate"
        (onBtnClick)="exportCSV()"
      >
      </app-button>
    </div>
  </div>

  <form [formGroup]="filterForm" class="page-filterbar">
    @if (this.serviceType != serviceName.MEDIATION_SERVICES) {
    <div class="application-filter-field auto-width-dropdown">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.SERVICE' | translate"
        [control]="filterForm.get('service')"
        [lovType]="lookupKey.DC_SR_TYPE"
        (onSelectionChange)="onServiceChange($event)"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [userType]="userType"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <!-- }  -->

    <div class="application-filter-field auto-width-dropdown">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.SUB_SERVICE' | translate"
        [control]="filterForm.get('subService')"
        [lovType]="lookupKey.SR_SUB_TYPE"
        (onSelectionChange)="applyFilter($event)"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [parentControl]="filterForm.get('service')"
        [parentLovType]="lookupKey.DC_SR_TYPE"
        [parentKey]="'Name'"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    }
    <!-- <div class="field-control">
      <app-option-field
        [label]="'MY_APPS.FILTER.MEMBERSHIP' | translate"
        [options]="memberships"
        [control]="filterForm.get('membership')"
      >
      </app-option-field>
    </div> -->
    <div class="application-filter-field auto-width-dropdown">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.STATUS' | translate"
        [control]="filterForm.get('status')"
        [lovType]="lookupKey.SR_STATUS"
        (onSelectionChange)="applyFilter($event)"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <div class="application-filter-field auto-width-dropdown">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.MEMBERSHIP' | translate"
        [options]="users"
        [labelKey]="'Name'"
        [valueKey]="'Value'"
        [control]="filterForm.get('membership')"
        (onSelectionChange)="filterByMembership($event)"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <div class="application-filter-field auto-width-dropdown">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.USER' | translate"
        [options]="linkedUsers"
        [labelKey]="'Login Name'"
        [valueKey]="'Login Name'"
        [control]="filterForm.get('user')"
        (onSelectionChange)="filterByLinkedUser($event)"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <div class="application-filter-field auto-width-dropdown">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.DATE' | translate"
        [options]="dateRanges"
        [control]="filterForm.get('days')"
        (onSelectionChange)="applyFilter($event)"
        [labelKey]="'label'"
        [valueKey]="'value'"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <div class="ms-auto w-full sm:w-60 pt-1.5">
      <div
        class="flex items-center border border-dc-navy text-dc-navy font-light overflow-hidden"
      >
        <input
          type="text"
          [placeholder]="'SEARCH_BY_APPLICATION' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
          formControlName="search"
          (keydown.enter)="search()"
          (keyup)="removeSearch($event)"
        />
        <button type="button" class="px-4 text-dc-navy" (click)="search()">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </form>
  <!-- Applications table (child component) -->
  @if (selectedRows && selectedRows.length > 0) {
  <div
    class="flex items-center gap-4 bg-[#E5F6FF] text-dc-navy py-4 px-4 mb-2 mt-2"
  >
    <span class="font-semibold text-sm">
       {{ "MY_APPS.SELECTED_ROW_MSG" | translate : { n: selectedRows.length } }}
    </span>
    <span class="ms-auto flex gap-5">
      @if(showPayAction){
      <app-button
        type="button"
        classesName="card-edge-cut-white text-dc-navy"
        [label]="'BUTTONS.PAY' | translate"
        (onBtnClick)="payForMulitple()"
      />
      }

      <!-- <app-button
        classesName="card-edge-cut-white text-dc-navy"
        [label]="'MY_DOCS.DELETE' | translate"
      />
      <app-button
        classesName="card-edge-cut-white text-dc-navy"
        [label]="'MY_DOCS.DOWNLOAD' | translate"
      /> -->
    </span>
  </div>
  }
  <app-table
    [tableHeadings]="
      serviceType == serviceName.MEDIATION
        ? [
            'MEDIATION_LIST.COL.ID' | translate,
            'MEDIATION_LIST.COL.COMPANY' | translate,
            'MEDIATION_LIST.COL.MEMBERSHIP' | translate,
            'MY_APPS.COL.DATE' | translate,
            'MEDIATION_LIST.COL.STATUS' | translate
          ]
        : [
            'MY_APPS.COL.APP' | translate,
            'MY_APPS.COL.SERVICE' | translate,
            'MY_APPS.COL.MEMBER' | translate,
            'MY_APPS.COL.INVOICE' | translate,
            'MY_APPS.COL.DATE' | translate,
            'MY_APPS.COL.STATUS' | translate
          ]
    "
    [dataKeys]="
      serviceType == serviceName.MEDIATION
        ? [
            'SR Number',
            'DC Respondant Name',
            'DC Member Name (English)',
            'DC Created',
            'Status'
          ]
        : [
            'SR Number',
            'SR Type',
            'Display Member Name',
            'DC Invoice Number',
            'DC Created',
            'Status'
          ]
    "
    [listData]="applications"
    [showActions]="true"
    [showPagination]="true"
    [showActionView]="false"
    [loader]="loader"
    [pageSize]="pageSize"
    [totalRecords]="totalRecords"
    [showActionMore]="true"
    [checkbox]="true"
    [showActionPay]="true"
    (onView)="viewApp($event)"
    (onPageChange)="pageChange($event)"
    (onSelectRow)="selectRow($event)"
    (onPayClick)="gotoPaymentPage($event)"
  >
  </app-table>
</div>
